import { EstimatedShippingFeeLabelTextHelper } from '../labelTextHelper/EstimatedShippingFeeLabelTextHelper';
import { HeaderItem } from '../../model/HeaderItem';

const excludedImportFieldList = ['productId', 'dateCreateAt', 'dateModifyAt'];

export const EstimatedShippingFeeHeaderHelper = {
    getHeaderItems(): HeaderItem[] {
        return [
            { text: EstimatedShippingFeeLabelTextHelper.getLabelText.sku, value: 'sku' },
            {
                text: EstimatedShippingFeeLabelTextHelper.getLabelText.estimatedShippingFeeAmount,
                value: 'estimatedShippingFeeAmount'
            },
            {
                text: EstimatedShippingFeeLabelTextHelper.getLabelText.dateEffectiveOn,
                value: 'dateEffectiveOn',
                format: 'date'
            },
            {
                text: EstimatedShippingFeeLabelTextHelper.getLabelText.dateCreateAt,
                value: 'dateCreateAt',
                format: 'datetime'
            },
            {
                text: EstimatedShippingFeeLabelTextHelper.getLabelText.dateModifyAt,
                value: 'dateModifyAt',
                format: 'datetime'
            }
        ];
    },

    getDateTimePropertyList(): string[] {
        return this.getHeaderItems()
            .filter((item) => item.format === 'datetime')
            .map((item) => item.value);
    },

    getDatePropertyList(): string[] {
        return this.getHeaderItems()
            .filter((item) => item.format === 'date')
            .map((item) => item.value);
    },

    getActionHeaderItem(): HeaderItem {
        return { text: EstimatedShippingFeeLabelTextHelper.getLabelText.action, value: 'action' };
    },

    getCsvHeader() {
        return [...this.getHeaderItems().map((item) => ({ key: item.value, text: item.text }))];
    },

    getHeaders() {
        return [...this.getHeaderItems(), this.getActionHeaderItem()];
    },

    getImportFields() {
        return this.getFilteredHeaderItems().reduce((acc, item) => {
            acc[item.value] = {
                required: false,
                label: item.text
            };
            return acc;
        }, {} as Record<string, { required: boolean; label: string }>);
    },

    getImportHeaders() {
        return this.getFilteredHeaderItems();
    },

    getFilteredHeaderItems() {
        return this.getHeaderItems().filter((header) => !excludedImportFieldList.includes(header.value));
    },

    getImportWithShippingFeeFields() {
        const fields = this.getFilteredHeaderItems().filter((item) => item.value === 'estimatedShippingFeeAmount');
        return fields.reduce((acc, item) => {
            acc[item.value] = {
                required: false,
                label: item.text
            };
            return acc;
        }, {} as Record<string, { required: boolean; label: string }>);
    },

    getImportWithShippingFeeHeaders() {
        return this.getHeaderItems().filter((item) => item.value === 'estimatedShippingFeeAmount');
    }
};
